export const discordLink = 'https://discord.gg/UEPaF3j5e6';
export const githubOrgLink = 'https://github.com/logto-io';
export const githubLink = 'https://github.com/logto-io/logto';
export const githubIssuesLink = 'https://github.com/logto-io/logto/issues';
export const githubReleasesLink = 'https://github.com/logto-io/logto/releases';
export const contactEmail = 'contact@logto.io';
export const contactEmailLink = `mailto:${contactEmail}`;
export const reservationLink = 'https://cal.com/logto/30min';
export const officialWebsiteLink = 'https://logto.io';
export const trustAndSecurityLink = `${officialWebsiteLink}/trust-and-security`;
export const pricingLink = `${officialWebsiteLink}/pricing`;
export const selfHostedPlansLink = `${officialWebsiteLink}/self-hosted-plans`;
export const logtoCloudConsoleLink = 'https://cloud.logto.io';
export const officialWebsiteContactPageLink = `${officialWebsiteLink}/contact`;
export const buildOfficialWebsiteContactPageUrl = (source: string) => {
  const url = new URL(officialWebsiteContactPageLink);

  url.searchParams.set('src', source);

  return url.toString();
};
export const entityPolicyLink = 'https://docs.logto.io/logto-cloud/system-limit';
export const logtoOssFeatureSupportLink =
  'https://docs.logto.io/logto-oss#feature-supported-by-logto-oss';

/** Docs link */
export const organizationsFeatureLink = '/organizations';
export const organizationConfigGuideLink =
  '/authorization/organization-template/configure-organization-template';
export const logtoThirdPartyGuideLink = '/docs/recipes/logto-as-idp/';
export const logtoThirdPartyAppPermissionsLink =
  '/docs/recipes/logto-as-idp/permissions-management/';
export const logtoThirdPartyAppBrandingLink = '/docs/recipes/logto-as-idp/branding-customization/';
export const appSpecificBrandingLink =
  '/docs/recipes/customize-sie/match-your-brand/#app-specific-branding';
export const organizationBrandingLink =
  '/customization/match-your-brand#organization-specific-branding';
export const organizationLogosForExperienceLink =
  '/docs/recipes/customize-sie/match-your-brand/#organization-specific-logos';
export const signingKeysLink = '/docs/references/openid-connect/signing-keys-rotation/';
export const organizationTemplateLink = '/authorization/organization-template';
export const organizationRoleLink =
  '/docs/recipes/organizations/understand-how-it-works/#organization-role';
export const organizationPermissionLink =
  '/docs/recipes/organizations/understand-how-it-works/#organization-permission';
export const profilePropertyReferenceLink = '/docs/references/users/#profile-1';
export const organizationJit = Object.freeze({
  enterpriseSso:
    '/docs/recipes/organizations/just-in-time-provisioning/#enterprise-sso-provisioning',
  emailDomain: '/docs/recipes/organizations/just-in-time-provisioning/#email-domain-provisioning',
});
export const integrateLogto = '/integrate-logto';
export const applicationDataStructure = '/integrate-logto/application-data-structure';
export const thirdPartyApp =
  '/integrate-logto/third-party-applications/oidc-oauth-third-party-applications';
/** The page is not published yet, it ships together with the dynamic app (CIMD) feature. */
export const dynamicApp = '/integrate-logto/third-party-applications/dynamic-apps';
export const protectedApp = '/integrate-logto/protected-app';
export const protectedAppLocalDev = '/integrate-logto/protected-app#local-development';
export const protectOriginServer = '/integrate-logto/protected-app#protect-your-origin-server';
export const appLevelAccessControl = '/integrate-logto/app-level-access-control';
export const deviceFlow = '/quick-starts/device-flow';
export const backchannelLogout = '/end-user-flows/sign-out#federated-sign-out-back-channel-logout';
export const authFlows = '/end-user-flows#authentication-flows';
export const termsAndPrivacy = '/end-user-flows/sign-up-and-sign-in/terms-and-privacy';
export const mfa = '/end-user-flows/mfa';
export const collectUserProfile = '/end-user-flows/collect-user-profile';
export const connectors = '/connectors';
export const socialConnectors = '/connectors/social-connectors';
export const emailConnectors = '/connectors/email-connectors';
export const builtInEmailService = '/connectors/email-connectors/built-in-email-service';
export const enterpriseSso = '/connectors/enterprise-connectors';
export const security = '/security';
export const captcha = '/security/captcha';
export const recaptchaEnterpriseBringYourUi =
  '/security/captcha/recaptcha-enterprise#bring-your-ui';
export const turnstileBringYourUi = '/security/captcha/turnstile#bring-your-ui';
export const sentinel = '/security/identifier-lockout';
export const emailBlocklist = '/security/blocklist';
export const passwordPolicy = '/security/password-policy';
export const spInitiatedSsoFlow = '/end-user-flows/enterprise-sso/sp-initiated-sso';
export const apiResources = '/authorization/global-api-resources';
export const rbac = '/authorization/role-based-access-control';
export const manageRolePermissions =
  '/authorization/role-based-access-control/configure-permissions#manage-role-permissions';
export const userManagement = '/user-management';
export const userCustomData = '/user-management/user-data#custom-data';
export const personalAccessToken = '/user-management/personal-access-token';
export const customIdToken = '/developers/custom-id-token';
export const userImpersonation = '/developers/user-impersonation';
export const webhooks = '/developers/webhooks';
export const secureWebhooks = '/developers/webhooks/secure-webhooks';
export const auditLogs = '/developers/audit-logs';
export const logtoCloud = '/logto-cloud';
export const logtoCloudTenantSettings = '/logto-cloud/tenant-settings';
export const logtoCloudDevTenantDataRetention = '/logto-cloud/dev-tenant-data-retention';
export const customDomain = '/logto-cloud/custom-domain#use-custom-domain';
export const customDomainFeatureLink = '/logto-cloud/custom-domain';
export const retrieveTokenStorage = '/secret-vault/federated-token-set#token-retrieval';

export const addOnPricingExplanationLink = 'https://docs.logto.io/logto-cloud/billing-and-pricing';
export const logtoCloudConsoleUrl = 'https://cloud.logto.io';

export const dateFnsDocumentationLink = 'https://date-fns.org/v2.30.0/docs/format';
